import { Injectable } from '@angular/core';
import { Patients } from "../../../models/list/patients.model";
import { CentreUrl } from "../../../shared/urls/centre.url";
import { BaseService } from "../../../shared/services/base.service";
@Injectable()
export class ResultSearchPatientService {

    constructor(public baseService: BaseService) {
    }


    getPatientList(param) {
        let url = CentreUrl.SEARCH_PATIENT;
        return this.baseService.postData(url, param);
    }

    getBaseClinic(param) {
        let url = CentreUrl.GET_BASE_CENTRE;
        return this.baseService.getData(url, param);
    }

    getSimilarPatientList(param) {
        let url = CentreUrl.SEARCH_SIMILAR_PATIENT;
        return this.baseService.postData(url, param);
    }
    addPatientToWaitingRoom(patientId: string, clinicId: string) {
        return this.baseService.postData(CentreUrl.ADD_PATIENT_TO_WAITING_ROOM.replace('{patientId}', patientId) + '?clinicId=' + clinicId, null);
    };
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/result-search-patient/result-search-patient.service.ts